import React, { useEffect } from 'react';

export default function ConfirmDialog({ message, detail, confirmLabel = 'Confirm', danger = false, saving = false, onConfirm, onCancel }) {
  useEffect(() => {
    const onKey = e => { if (e.key === 'Escape' && !saving) onCancel(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [saving, onCancel]);

  const iconColor = danger ? 'var(--danger)' : 'var(--brand)';

  return (
    <div
      onClick={saving ? undefined : onCancel}
      style={{
        position: 'fixed', inset: 0, zIndex: 10000,
        background: 'rgba(0,0,0,0.45)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        padding: 24,
      }}
    >
      <div
        onClick={e => e.stopPropagation()}
        style={{
          background: 'var(--surface)',
          border: '1px solid var(--border)',
          borderRadius: 12,
          padding: '24px 28px',
          width: 'fit-content',
          minWidth: 300,
          maxWidth: 460,
          boxShadow: '0 20px 60px rgba(0,0,0,0.2)',
        }}
      >
        {/* Message + detail — balanced wrapping, no orphans */}
        <div style={{ marginBottom: 20 }}>
          <div style={{
            fontSize: 15, fontWeight: 600, color: 'var(--text)',
            lineHeight: 1.4, marginBottom: detail ? 6 : 0,
            textWrap: 'balance',
          }}>
            {message}
          </div>
          {detail && (
            <div style={{
              fontSize: 13, color: 'var(--text-3)', lineHeight: 1.6,
              textWrap: 'pretty',
            }}>
              {detail}
            </div>
          )}
        </div>

        {/* Footer: warning icon left-aligned, buttons right */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          {/* Warning icon — left */}
          <svg viewBox="0 0 24 24" fill="none" stroke={iconColor}
            strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
            style={{ width: 24, height: 24, flexShrink: 0, opacity: 0.8 }}>
            {danger
              ? <><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></>
              : <><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></>
            }
          </svg>

          {/* Spacer */}
          <div style={{ flex: 1 }} />

          {/* Buttons — right */}
          <button className="btn" onClick={onCancel} disabled={saving}>
            Cancel
          </button>
          <button
            className={`btn ${danger ? 'danger filled' : 'primary'}`}
            onClick={onConfirm}
            disabled={saving}
            style={{ minWidth: 100 }}
          >
            {saving ? 'Saving…' : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
